const KIOSK_DEVICE_UUID_KEY = 'jobcards.kiosk.deviceUuid'

function canUseBrowserStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
}

function generateDeviceUuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  return `kiosk-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`
}

export function getOrCreateKioskDeviceUuid() {
  if (!canUseBrowserStorage()) {
    return generateDeviceUuid()
  }

  const existing = window.localStorage.getItem(KIOSK_DEVICE_UUID_KEY)
  if (existing && existing.trim().length >= 8) {
    return existing
  }

  const next = generateDeviceUuid()
  window.localStorage.setItem(KIOSK_DEVICE_UUID_KEY, next)
  return next
}

export function clearKioskDeviceUuid() {
  if (!canUseBrowserStorage()) return
  window.localStorage.removeItem(KIOSK_DEVICE_UUID_KEY)
}
